/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Lead
 *
 * 2 = Phone
 *
 * 3 = Working
 *
 * 4 = Prospecting
 */
export enum ContactMethodCrm {
  Lead = 1,
  Phone = 2,
  Working = 3,
  Prospecting = 4,
}
